import React from 'react';
import { MapPin, Mail, Clock } from 'lucide-react';
import { Button } from './ui/Button';
interface ContactProps {
  onJoinClick?: () => void;
}
export function Contact({
  onJoinClick
}: ContactProps) {
  return <section id="contact" className="py-20 bg-[#fbf7dd]" data-id="element-116">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-117">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-118">
          {/* Contact Info */}
          <div data-id="element-119">
            <h2 className="text-3xl md:text-5xl font-display font-bold text-gray-900 mb-6" data-id="element-120">
              Location
            </h2>
            <p className="text-lg text-gray-600 mb-10" data-id="element-121">
              Have questions about our caravan and boat storage facility? We're
              here to help. Contact us today to secure your spot.
            </p>

            <div className="space-y-8" data-id="element-122">
              <div className="flex items-start" data-id="element-123">
                <div className="flex-shrink-0 bg-[#175445]/10 p-3 rounded-lg" data-id="element-124">
                  <MapPin className="h-6 w-6 text-[#175445]" data-id="element-125" />
                </div>
                <div className="ml-4" data-id="element-126">
                  <h3 className="text-lg font-bold text-gray-900" data-id="element-127">Location</h3>
                  <p className="text-gray-600 mt-1" data-id="element-128">
                    Perth's Northern Corridor
                    <br data-id="element-129" />
                    Final site to be confirmed. Locations under consideration
                    include Bullsbrook and Neerabup.
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-130">
                <div className="flex-shrink-0 bg-[#175445]/10 p-3 rounded-lg" data-id="element-131">
                  <Mail className="h-6 w-6 text-[#175445]" data-id="element-132" />
                </div>
                <div className="ml-4" data-id="element-133">
                  <h3 className="text-lg font-bold text-gray-900" data-id="element-134">Email</h3>
                  <p className="text-gray-600 mt-1" data-id="element-135">
                    <a href="mailto:bookings@holdmyvan.com.au" className="hover:text-[#175445]" data-id="element-136">
                      bookings@holdmyvan.com.au
                    </a>
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-137">
                <div className="flex-shrink-0 bg-[#175445]/10 p-3 rounded-lg" data-id="element-138">
                  <Clock className="h-6 w-6 text-[#175445]" data-id="element-139" />
                </div>
                <div className="ml-4" data-id="element-140">
                  <h3 className="text-lg font-bold text-gray-900" data-id="element-141">
                    Access Hours
                  </h3>
                  <p className="text-gray-600 mt-1" data-id="element-142">
                    Monday - Sunday: 7:00 AM - 7:00 PM
                    <br data-id="element-143" />
                    <span className="text-sm text-gray-500" data-id="element-144">
                      (24/7 access available on request)
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact CTA */}
          <div className="bg-gray-50 p-8 rounded-2xl border border-gray-100 shadow-sm flex flex-col items-center justify-center text-center" data-id="element-145">
            <h3 className="text-2xl font-display font-bold text-gray-900 mb-4" data-id="element-146">
              Ready to get started?
            </h3>
            <p className="text-gray-600 mb-8 max-w-md" data-id="element-147">
              Click below to join our priority list and be among the first to
              secure your storage bay with early bird pricing.
            </p>
            <Button variant="secondary" size="lg" onClick={onJoinClick} data-id="element-148">
              JOIN THE PRIORITY LIST
            </Button>
          </div>
        </div>
      </div>
    </section>;
}